import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ChatComponent from '../../components/ChatComponent';

export default function ChatPage() {
    return (
        <Box sx={{ p: 3, height: '90vh', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h5" sx={{ mb: 2, color: '#20ac9c', fontWeight: 'bold' }}>
                Chat Interno
            </Typography>
            <Paper sx={{ flex: 1, p: 2, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <ChatComponent />
            </Paper>
        </Box>
    );
}
